
import React from 'react';
import { Peer } from '../types/financial';
import { convertRevenueToCrores, formatCurrency } from '../utils/financial';
import ErrorBoundary from './ErrorBoundary';
import LoadingSpinner from './LoadingSpinner';

interface PeerTableProps {
  peers: Peer[];
  isLoading?: boolean;
}

const PeerTable: React.FC<PeerTableProps> = ({ peers, isLoading = false }) => {
  if (isLoading) {
    return <LoadingSpinner  />;
  }

  if (!peers || peers.length === 0) {
    return (
      <div className="text-center py-8 text-[#8b7355]/70">
        <p>No peer data available.</p>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gradient-to-r from-[#d9cba6]/20 to-[#d9cba6]/10">
              <th className="text-left p-4 font-semibold text-[#8b7355] border-b border-[#d9cba6]/30">CIN</th>
              <th className="text-left p-4 font-semibold text-[#8b7355] border-b border-[#d9cba6]/30">Company Name</th>
              <th className="text-left p-4 font-semibold text-[#8b7355] border-b border-[#d9cba6]/30">City</th>
              <th className="text-right p-4 font-semibold text-[#8b7355] border-b border-[#d9cba6]/30">Revenue (₹ CR)</th>
            </tr>
          </thead>
          <tbody>
            {peers.map((peer, index) => (
              <tr key={peer.cin} className={`border-b border-[#d9cba6]/20 hover:bg-[#d9cba6]/8 transition-colors ${peer.legalName.includes('MILKLANE') ? 'bg-gradient-to-r from-[#d9cba6]/20 to-[#d9cba6]/10 font-semibold' : ''}`}>
                <td className="p-4 text-sm font-mono text-[#8b7355]/80">{peer.cin}</td>
                <td className="p-4 text-[#2c2c2c]">{peer.legalName}</td>
                <td className="p-4 text-[#8b7355]">{peer.city}</td>
                <td className="p-4 text-right font-bold text-[#c4965f]">
                  {formatCurrency(convertRevenueToCrores(peer.revenue))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ErrorBoundary>
  );
};

export default PeerTable;
